<template>
  <client-only>
    <Teleport to="body">
      <dialog
        ref="dialog"
        v-bind="attrs"
        class="mt-(--_dialog-m-t) mr-(--_dialog-m-r) mb-(--_dialog-m-b) ml-(--_dialog-m-l) h-(--_dialog-height) max-h-(--_dialog-max-height) w-(--_dialog-width) max-w-(--_dialog-max-width) translate-x-(--_dialog-translate-x) translate-y-(--_dialog-translate-y) rounded-tl-(--_dialog-r-tl) rounded-tr-(--_dialog-r-tr) rounded-br-(--_dialog-r-br) rounded-bl-(--_dialog-r-bl) backdrop:bg-black backdrop:opacity-0 open:flex open:translate-x-0 open:translate-y-0 open:flex-col open:backdrop:opacity-50 open:starting:translate-x-(--_dialog-translate-x) open:starting:translate-y-(--_dialog-translate-y) open:backdrop:starting:opacity-0 [&>section]:grow [&>section]:overflow-y-auto"
        @click.self="onClose"
      >
        <slot></slot>
      </dialog>
    </Teleport>
  </client-only>
</template>

<script setup>
defineOptions({
  inheritAttrs: false,
});

const emits = defineEmits(["clickOut"]);

const attrs = useAttrs();

const dialog = useTemplateRef("dialog");

function onClose(event) {
  if (!dialog.value) {
    return;
  }
  const rect = dialog.value.getBoundingClientRect();

  const clickedInDialog =
    rect.top <= event.clientY &&
    event.clientY <= rect.top + rect.height &&
    rect.left <= event.clientX &&
    event.clientX <= rect.left + rect.width;

  if (!clickedInDialog) {
    emits("clickOut");
  }
}

defineExpose({
  showModal: () => dialog.value?.showModal(),
  close: () => dialog.value?.close(),
  customElement: () => dialog.value,
});
</script>

<style scoped>
dialog {
  --_dialog-width: var(--dialog-width, 100dvw);
  --_dialog-height: var(--dialog-height, 100dvh);

  --_dialog-max-width: var(--dialog-max-width, 100dvw);
  --_dialog-max-height: var(--dialog-max-height, 100dvh);

  --_dialog-translate-x: var(--dialog-translate-x, 0);
  --_dialog-translate-y: var(--dialog-translate-y, 0);
  --_dialog-m-t: var(--dialog-m-t, auto);
  --_dialog-m-b: var(--dialog-m-b, auto);
  --_dialog-m-l: var(--dialog-m-l, auto);
  --_dialog-m-r: var(--dialog-m-r, auto);

  --_dialog-r-tl: var(--dialog-r-tl, 0);
  --_dialog-r-tr: var(--dialog-r-tr, 0);
  --_dialog-r-bl: var(--dialog-r-bl, 0);
  --_dialog-r-br: var(--dialog-r-br, 0);

  --_dialog-duration: var(--dialog-duration, 350ms);

  transition:
    overlay var(--_dialog-duration) ease-in-out allow-discrete,
    translate var(--_dialog-duration) ease-in-out allow-discrete,
    transform var(--_dialog-duration) ease-in-out allow-discrete,
    display var(--_dialog-duration) step-end allow-discrete,
    opacity var(--_dialog-duration) ease-in-out allow-discrete,
    overlay var(--_dialog-duration) ease-in-out allow-discrete,
    flex-direction var(--_dialog-duration) step-end allow-discrete;

  &::backdrop {
    transition:
      overlay var(--_dialog-duration) ease-in-out allow-discrete,
      opacity var(--_dialog-duration) ease-in-out allow-discrete;
  }
}
</style>
